<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Users">Users</span>
      </div>

      <!-- Center -->
      <div class="app-toolbar-center">
    <div *ngIf="startupService.selectedRole === 'organization'">
      <button mat-fab color="primary" (click)="openAddDialog()" i18n-matTooltip="@@Add User" matTooltip="Add User"><i class="material-icons">add</i></button>
    </div>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="users"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content app-table-content">
        <app-table *ngIf="columns && eventHandler && renderedData" [columns]="columns" [eventHandler]="eventHandler" [data]="renderedData" [expandedTableRowTemplate]="expandedTableRowTemplate" [dataServiceStatus]="userService.loadingState" [showFilters]="true">
          <ng-template #expandedTableRowTemplate let-element>
            <app-user [user]="element"></app-user>
          </ng-template>
        </app-table>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
